import {
  func, string, array, number,
} from 'prop-types';
import { isNil } from 'ramda';
import React, {
  forwardRef, useCallback, useState, useMemo,
} from 'react';

import { Icon } from '@ezugi/primitives';
import { DeviceInfo } from '@ezugi/utils';

import { Header, sectionIconClassName } from '../../../views/GameBoard/sections/style';
import DropdownMenu from '../Dropdown';
import { Container, Right } from './style';

const ToggleSelect = forwardRef(
  (
    { list, defaultActive, foreground, background, onToggle, iconSvg, title },
    ref
  ) => {
    const [ selectedIndex, setSelectedIndex ] = useState(defaultActive);
    const onSelectHandler = useCallback(
      (index) => {
        onToggle(index);
        setSelectedIndex(index);
      },
      [ onToggle ]
    );
    const selected = useMemo(() => list[selectedIndex], [ list, selectedIndex ]);

    return (
      <Container
        {...{
          style: {
            ...(!isNil(foreground) && { color: foreground, fill: foreground }),
            ...(!isNil(background) && { background }),
          },
        }}
      >
        <Header>
          <Icon
            svg={iconSvg}
            noDefaultStyling={true}
            className={sectionIconClassName}
          />
          <span>
            {title}
          </span>
        </Header>
        {list.length > 1 ? (
          <Right isHandheld={DeviceInfo.isHandheld}>
            <DropdownMenu title={selected} items={list} onSelect={onSelectHandler} ref={ref} />
          </Right>
        ) : null}
      </Container>
    );
  }
);

ToggleSelect.propTypes = {
  list: array,
  defaultActive: number,
  background: string,
  foreground: string,
  onToggle: func,
  iconSvg: string,
  title: string,
  top: number,
};

ToggleSelect.defaultProps = {
  defaultActive: 0,
  onToggle: () => undefined,
};

export default ToggleSelect;
